// import React from "react";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import MakeAppoinment from '../components/make-appoinment';

import useGaspAnimations from '../components/useGsapAnimations'

function Services() {
 useGaspAnimations()
 
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
 

{/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Our Products</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Products</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start services page area--> */}
<section className="services-page-area">
    <div className="container">
        <div className="row">
             <div className="row bottom">
            <div className="sec-title">
            <h1 className="title-anim"><span>INDUS offers a wide range of products and services that includes:</span></h1>
            <p className="title-anim">
                Chiller Packages, Atmospheric Gas Vaporizer, Heat Pumps, Slurry Ice System, RSW Package ,Condenser, Cold Stores & Cold Chain Systems, Heat Exchangers, Air Cooling Coils, Pressure Vessels, Air Purger, Process Refrigeration Audits and Design & Implementation Consultancy.
             </p>
        </div>
           
            
        </div>
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Industrial-Refrigeration-Refpacks.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Productiocns/01-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                         <h3>Skid Mounted Refrigeration Pack</h3>
                        <ul>
                            <li className='clouser'>Low Charge Ammonia</li>
                                                        <li className='clouser'>Pump feed Ammonia </li>
                                                        <li className='clouser'>Freon DX </li>
                                                        <li className='clouser'>CO2  Subcritical </li>
                                                        <li className='clouser'>CO2 Transcritical</li>
                        </ul>
                        <a href="/industrial-refrigeration" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Cooling-&-Chilling-Systems.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/02-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                        <h3>Process Refrigeration Systems </h3>
                         <ul>
                              <li className='clouser'>Process & Instant Milk Chiller</li>
                                                    <li className='clouser'>Refrigerated Sea Water </li>
                                                    <li className='clouser'>Boil Off Gas Condensing system</li>
                                                    <li className='clouser'>Gas Liquification</li>
                                                    <li className='clouser'>Turbine Inlet Air cooling system</li>
                                                    <li className='clouser'>CO2 Atmospheric & Vapouriser</li>
                         </ul>

                        <a href="/cooling-and-chilling" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Heat-Pumps.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/03-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                          <h3>Heat Pumps</h3>
                    <ul className="pull-left">
                       <li className='clouser'>Air Source Heat Pump</li>
                                                    <li className='clouser'>Water Source Heat Pump</li>
                                                    <li className='clouser'>Dual Source Heat Pump</li>
                                                    <li className='clouser'>Hybrid Heat Pump</li>

                    </ul>
                        <a href="/heat-pumps" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Container-Plant.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/04-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                       <h3> ICE Production Systems</h3>

                    <ul className="pull-left">
                        <li className='clouser'>Block & Flake ice systems</li>
                                                    <li className='clouser'>Tube ice systems</li>
                                                    <li className='clouser'>Plate / slice ice systems </li>
                                                    <li className='clouser'>Slurry ice systems </li>
                                                    <li className='clouser'>Cube / commercial ice systems</li>
                    </ul>
                        <a href="/ICE-production-systems" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Economizer.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/05-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                               <h3>Ammonia Liquid  Recirculator Package</h3>
                    <ul className="pull-left">
                         <li className='clouser'>Ice Manufacturing</li>
                                                    <li className='clouser'>Cold Storage</li>
                                                    <li className='clouser'>Food Processing</li>
                                                    <li className='clouser'>Dairy & Beverage</li>
                    </ul>
                        <a href="/ammonia-recirculator-package" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/cooledcondenser.jpg" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/09-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                           <h3>Cooling Condenser</h3>

                    <ul className="pull-left">
                         <li className='clouser'>Evaporative Condensor</li>
                                                    <li className='clouser'>Shell and Tube water cooled</li>
                                                    <li className='clouser'>Air cooled</li>   
                    </ul>
                        <a href="/cooling-condenser" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}

             {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/IQF_Freezer_Dairy_370x200.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                                 <img src='assets/images/Productiocns/10-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                       <h3>Freezers</h3>

                    <ul className="pull-left">
                        <li className='clouser'>IQF & Blast Freezer </li>
                                                    <li className='clouser'>Contact Freezer </li>
                                                    <li className='clouser'>Compact Freezer </li>
                                                    <li className='clouser'>Fluidised bed Freezer</li>
                                                    <li className='clouser'>Brine Freezer</li>
                    </ul>

                        <a href="/pressure-vessels" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}


                {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Pressure-Vessels.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/07-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                       <h3>Pressure Vessels</h3>

                    <ul className="pull-left">
                     <li className='clouser'>Suction Accumulators</li>
                                                    <li className='clouser'>Receivers</li>
                                                    <li className='clouser'>Chiller Barrels and Subcoolers</li>
                                                    <li className='clouser'>Oil Separators</li>
                    </ul>

                        <a href="/pressure-vessels" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}


               {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Support-Services-.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/08-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                      <h3> Control Systems</h3>
                        <ul>
               
                            <li className='clouser'>Sensors and Controls </li>
                                                        <li className='clouser'>Control Panel</li>
                                                        <li className='clouser'>SCADA system</li>
                                                        <li className='clouser'>Automation</li>
                                                        <li className='clouser'>Monitoring Software</li>
                        </ul>
                        <a href="/control-systems" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
        </div>
    </div>
</section>

 {/* <!--Start appoinment area--> */}
                 <MakeAppoinment/>
                    {/* <!--End appoinment area--> */}
{/* <!--End services page area--> */}

          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Services;

